import Image from "next/image";
import Link from "next/link";

export default function CoverImage({ title, coverImage, slug }) {
  const image = (
    <Image
      alt={title}
      className="transition-all"
      src={coverImage?.node.sourceUrl}
      fill
      sizes="100vw"
      style={{
        objectFit: "cover",
      }}
    />
  );
  return (
    <div className="sm:mx-0">
      {slug ? (
        <Link href={`/blog/${slug}`} aria-label={title} title={title}>
          {image}
        </Link>
      ) : (
        {}
      )}
    </div>
  );
}
